const convertObjToArray = (frequency) => Object.keys(frequency).filter((key) => frequency[key] > 1).map((key) => ({
  word: key,
  frequency: frequency[key],
}));

module.exports = convertObjToArray;
